import template from "./custom-taxform-menu-item.html";
import { AccountsService } from "../Http/Accounts/AccountsService";

ko.components.register('custom-taxform-menu-item', {
    template: template,
    viewModel: {
        createViewModel: function (params, componentInfo) {
            return new CustomTaxFormMenuItem(params, componentInfo);
        }
    }
});

function CustomTaxFormMenuItem(params, componentInfo) {
    this.cssClass = ko.observable(params.cssClass || 'main-navi_link-secondary');
    // Invoke accounts service only if user is authenticated
    if ($.cdh.user.authenticated) {
        this.accountId = ko.observable();
        this.menuText = ko.observable(params.name);
        this.isStatement = params.isStatement ? params.isStatement.toLowerCase() === 'true' : false;
        this.link = ko.observable(params.pageUrl);
        this.accountService = new AccountsService();
        this.accountService.getListHsaAsync($.cdh.enums.planYear.all).then(function(accounts) {
            // Construct the URL for TaxForms only when accounts are available
            // & it conatins HSA account but not on VEBA account.
            if (accounts && accounts.length > 0) {
                let filteredHSAAccounts = accounts.filter(ac => ac.IsHsa == true);
                if (!this.isStatement) {
                    filteredHSAAccounts = filteredHSAAccounts.filter(ac => ac.IsVeba == false);
                }
                if (filteredHSAAccounts.length > 0) {
                    let sortedHSAAccountList = filteredHSAAccounts.sort((a, b) => a.Priority - b.Priority);
                    this.link(this.link() + "?accountId=" + sortedHSAAccountList[0].AccountId);
                }
                else {
                    $(componentInfo.element).closest("li").remove();
                }
            }
            else {
                $(componentInfo.element).closest("li").remove();
            }
        }.bind(this));
    }
}